module.exports = __webpack_public_path__ + "static/media/asset_3.6c621b39.png";